<template>
    <div
        class="md-form get-more-info-v7"
        :class="{
            'get-more-info-building': isBuildingDetail,
            'get-more-info-building-mobile': isBuildingDetail && isMobileSize
        }"
        :style="{ backgroundColor: bgColor }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div
                v-if="title"
                class="mg-title"
                v-html="formatFontSize(title, '--mg-title-size')"
            ></div>
            <div
                class="form-container"
                :style="{ backgroundColor: formBgColor }"
            >
                <info-agent
                    v-if="!isBuildingDetail"
                    :agent="agent"
                    :licenseName="licenseName"
                />
                <div class="info-right">
                    <info-form
                        :registerRole="registerRole"
                        :tag="tag"
                        :questionnaire="questionnaire"
                        :onSubmitOption="onSubmitOption"
                        :formList="formList"
                        messageOutside
                        :showTitle="false"
                        :lenderStyle="lenderStyle"
                        :defaultMsg="defaultMsg"
                        :submitText="submitOptionText"
                        :submitStyle="{
                            backgroundColor: submitBgColor,
                        }"
                        :registerLogin="registerLogin"
                        @done="handleShowToast"
                        disclaimerColor="#8b93a7"
                    />
                </div>
                <form-toast
                    v-model:visible="formToastVisible"
                    v-bind="formToastOption"
                    @confirm="handleToastConfirm"
                />
            </div>
        </module-box>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { useBuildingStore } from '@/store';
import common from '../index';
import infoAgent from '../info-agent.vue';
import infoForm from '../info-form.vue';
import formToast from '@/components/form-toast';
import { normal } from '../../defaultSpacing';

export default {
    mixins: [common],
    data: function() {
        return {
            ...normal
        };
    },
    components: {
        infoAgent,
        infoForm,
        formToast
    },
    computed: {
        ...rootMapState(useBuildingStore, {
            buildingInfo: 'buildingInfo',
            listingDetailInfo: 'listingDetailInfo'
        }),

        streetAddress() {
            // building default page's form show streetAddress， remove # Number
            if (
                this.listingDetailInfo?.chimeComplex &&
                this.listingDetailInfo.chimeComplex !== 'null'
            ) {
                return this.listingDetailInfo.chimeComplex;
            } else {
                const addr = this.listingDetailInfo?.streetAddress || '';
                const newAddr = addr.split('#')[0];
                return newAddr;
            }
        }
    },
    mounted() {
        if (this.isBuildingDetail) {
            const { buildingName, buildingAddress } = this.buildingInfo || {};
            const name =
                buildingName ||
                buildingAddress ||
                this.streetAddress ||
                'this listing';
            this.defaultMsg = `I am interested in ${name}.`;
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.get-more-info-v7 {
    .form-container {
        position: relative;
        display: flex;
        background-color: #f5f6fa;
        .info-agent {
            position: relative;
            flex-shrink: 0;
            width: 360px;
            min-height: 440px;
            .agent-image {
                width: 100%;
                height: 100%;
            }
            .agent-detail {
                z-index: var(--level-low);
                position: absolute;
                bottom: 20px;
                left: 20px;
                right: 20px;
                color: #fff;
                .name {
                    font-size: 24px;
                    font-family: var(--font-bold);
                    line-height: 1.1;
                    text-shadow: 0 1px 1px rgba(8, 17, 38, 0.3);
                    margin-bottom: 10px;
                }
                .position,
                .phone {
                    margin-top: 10px;
                    font-size: 14px;
                    line-height: 20px;
                }
                .position {
                    span {
                        white-space: nowrap;
                    }
                }
            }
            &::after {
                position: absolute;
                content: '';
                background-image: linear-gradient(
                    180deg,
                    rgba(8, 17, 38, 0),
                    rgba(8, 17, 38, 0.7)
                );
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 102px;
                opacity: 0.8;
            }
        }
        .info-right {
            padding: 40px 40px 40px 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex: 1;
            @include placeholderColor(#8b93a7);
            .input-content {
                display: flex;
                flex-wrap: wrap;
            }
            .basic-info {
                flex: 1;
                width: 270px;
                min-width: 230px;
                display: flex;
                flex-wrap: wrap;
                .input-box {
                    margin-left: 20px;
                    position: relative;
                    margin-bottom: 20px;
                    min-width: 230px;
                    flex: 1;
                    .mg-error {
                        position: absolute;
                        left: 0;
                        bottom: -18px;
                    }
                    &.meetTime {
                        .el-input {
                            width: 100%;
                        }
                        .el-input__prefix {
                            left: 15px;
                        }
                        input {
                            text-indent: 20px;
                            color: #000000;
                        }
                    }
                }
                .input-box[class*='paragraphText'] {
                    width: 100%;
                    textarea {
                        height: 100px;
                        padding: 20px;
                    }
                }
                input,
                textarea {
                    display: inline-block;
                    font-size: 14px;
                    height: 50px;
                    background-color: #fff;
                    box-shadow: none;
                    border: none;
                    width: 100%;
                    padding-left: 20px;
                }
            }
            .message {
                flex: 1;
                width: 270px;
                min-width: 230px;
                min-height: 100px;
                margin-left: 20px;
                margin-bottom: 20px;
                position: relative;
                display: flex;
                flex-direction: column;
                .input-container {
                    height: 100%;
                }
                textarea {
                    flex: 1;
                    width: 100%;
                    height: 100%;
                    box-shadow: none;
                    border: none;
                    padding: 20px;
                    font-size: 14px;
                }
                .mg-error {
                    position: absolute;
                    left: 0;
                    bottom: -18px;
                }
            }
            .submit-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                margin-left: 20px;
            }
            .submit-box {
                text-align: right;
                flex: 1;
            }
            .submit {
                display: inline-block;
                height: 40px;
                min-width: 120px;
                max-width: 100%;
                padding: 0 20px;
                text-align: center;
                vertical-align: middle;
                font-size: 16px;
                font-family: var(--mg-button-font);
            }
        }
    }
    &.get-more-info-building {
        background: #fff !important;
        .form-container {
            .info-right {
                padding: 30px 30px 30px 10px !important;
            }
        }
    }
    &.get-more-info-building-mobile {
        .form-container {
            .info-right {
                padding: 0 !important;
                margin-top: 0 !important;
                flex-direction: column-reverse !important;
            }
        }
    }
    input[type='button'].toast-btn2 {
        font-family: var(--font-medium);
    }
    @include media-800 {
        .form-container {
            flex-direction: column;
            padding: 20px 15px;
            .info-agent {
                width: 100%;
                display: flex;
                margin-right: 0;
                height: auto;
                min-height: auto;
                .agent-image {
                    width: 50px;
                    height: 50px;
                }
                .agent-detail {
                    position: static;
                    margin-left: 16px;
                    .name {
                        font-size: 15px;
                        text-shadow: none;
                        margin-bottom: 6px;
                        color: #4a4a60;
                    }
                    .position,
                    .phone {
                        color: #8b93a7;
                        margin-top: 0;
                        font-size: 12px;
                        line-height: 14px;
                    }
                }
                &:after {
                    display: none;
                }
            }
            .info-right {
                width: 100%;
                padding: 0;
                margin-top: 20px;
                .input-content {
                    flex-direction: column;
                }
                .basic-info {
                    width: 100%;
                    margin-left: 0;
                    .input-box {
                        margin-bottom: 12px;
                        width: 100%;
                        min-width: auto;
                        flex: none;
                        margin-left: 0;
                        .mg-error {
                            position: static;
                        }
                        &.meetTime {
                            .el-input__prefix {
                                left: 5px;
                            }
                            input {
                                text-indent: 26px;
                            }
                        }
                    }
                    .input-box[class*='paragraphText'] {
                        textarea {
                            padding: 12px 10px;
                            font-size: 12px;
                        }
                    }
                    input {
                        height: 40px;
                        padding-left: 10px;
                        font-size: 12px;
                    }
                }
                .message {
                    width: 100%;
                    margin-left: 0;
                    textarea {
                        flex: none;
                        height: 100px;
                        padding: 12px 10px;
                        font-size: 12px;
                    }
                    .mg-error {
                        position: static;
                    }
                }
                .submit-content {
                    flex-direction: column;
                    margin-left: 0;
                }
                .submit-box {
                    width: 100%;
                }
                .submit {
                    display: block;
                    width: 100%;
                }
            }
        }
    }
    .disclaimer-wrap {
        padding: 0 0 0 20px;
        @include media-800 {
            padding: 0;
        }
    }
    .chime-datepicker .date-picker-input-wrapper i.iconfont{
        top: 4px;
        @include media-800{
            top: -1px;
        }
    }
}
</style>
